import { ProductItem } from 'components/flash-sale/flash-sale-create/product-item/ProductItem'
import { useFetch } from 'services/useFetch'
import { useEffect, useState } from 'react'
import { constructOptionsSelect } from 'utils/utils'
import { API_FLASH_SALE } from 'services/apiFlashSale'

export const ProductItemContainer = ({ sectionRef, flashSaleDetail, errorForm, onChangeForm }) => {
    const copyItems = [...(flashSaleDetail?.products || [])]
    const { fetching: getProductList } = useFetch(API_FLASH_SALE.PRODUCT_LIST)
    const [optionsProduct, setOptionsProduct] = useState([])

    const onFilterOptions = (index) => {
        const filterProducts = copyItems?.filter((_, i) => i !== index)
        const selectedProductIds = filterProducts?.map((item) => item?.product_id?.value)
        return optionsProduct?.filter((item) => !selectedProductIds?.includes(item?.value))
    }

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newList = constructOptionsSelect(response?.data, 'name', 'id')
            setOptionsProduct(newList)
        })
    }

    const setItems = (items) => {
        onChangeForm({ products: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                product_id: null,
                price: null,
                stock_quantity: null,
                limit_purchase: null,
            },
        ])
    }

    useEffect(() => {
        onSearchProduct()
    }, [])

    const props = {
        sectionRef: sectionRef?.product_item,
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        onFilterOptions,
        onSearchProduct,
        errorForm,
    }

    return <ProductItem {...props} />
}
